import {
  require_classnames
} from "./chunk-PXJBVWC7.mjs";
import {
  __objRest,
  __spreadValues,
  __toESM
} from "./chunk-WI73T6NA.mjs";

// src/spinner/index.tsx
var import_classnames = __toESM(require_classnames());

// src/spinner/styles.ts
import { css } from "@emotion/react";
var SpinnerCss = (props) => {
  var _a, _b;
  return css`
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  width: ${(_a = props == null ? void 0 : props.width) != null ? _a : 12}px;
  height: ${(_b = props == null ? void 0 : props.height) != null ? _b : 12}px;
  border-radius: 50%;
  display: inline-block;
  border-top: 1px solid white;
  border-right: 2px solid white;
  border-bottom: 3px solid white;
  border-left: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
`;
};

// src/spinner/index.tsx
import { jsx } from "@emotion/react/jsx-runtime";
var Spinner = (props) => {
  const _a = props, { className, width, height } = _a, rest = __objRest(_a, ["className", "width", "height"]);
  const classes = (0, import_classnames.default)("pq-spinner", className);
  return /* @__PURE__ */ jsx(
    "span",
    __spreadValues({
      "data-cy": "pq-spinner",
      className: classes,
      css: SpinnerCss({
        width,
        height
      })
    }, rest)
  );
};

export {
  Spinner
};
//# sourceMappingURL=chunk-JYYKO2MH.mjs.map